import styled, { css, type RuleSet } from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getBodyStyle, getColor, type Theme } from 'styles/theme';

const variantStyling: {
  [variant: string]: RuleSet<any>;
} = {
  'card-column': css<{ theme: Theme }>`
    display: flex;
    flex-direction: column;
    gap: 16px;
    
    .item-description {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
      ${getBodyStyle('graphikCompact', { default: 'default' })};
      max-height: calc(1.5 * 1rem * 3);
    }
  `,
  'card-hero': css<{ theme: Theme }>`
    display: flex;
    flex-direction: column;
    gap: 16px;

    .item-description {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      text-overflow: ellipsis;
      ${getBodyStyle('graphikCompact', { default: 'default' })}
      max-height: calc(1.5 * 1rem * 4);
    }
  `,
  'card-noimage': css<{ theme: Theme }>`
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (${breakpoint.mdMin}) {
      gap: 24px;
    }
    
    .item-description {
      ${getBodyStyle('graphikCompact', { default: 'default' })};
    }

    .cta {
      display: inline-flex;
      align-self: flex-start;
    }
  `,
  'card-row': css<{ theme: Theme }>`
    display: grid;
    grid-template-areas:
      "img title"
      "img description";
    gap: 24px;
    grid-template-rows: auto 1fr;
    grid-template-columns: 115px 1fr;

    .item-description {
      display: none;
    }

    @media (${breakpoint.mdMin}) {
      gap: 16px 24px;
      grid-template-columns: 204px 1fr;

      .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
        text-overflow: ellipsis;
        ${getBodyStyle('graphikCompact', { default: 'default' })}
        max-height: calc(1.5 * 1rem * 4);
      }
    }
  `,
};

export const Wrapper = styled.div<{ theme: Theme; $variant: string }>`
  ${({ $variant }) => variantStyling[$variant]};

  .item-image {
    grid-area: img;
    aspect-ratio: 3/2;
    background: ${getColor('surfaceTertiary')};
    img {
      aspect-ratio: 3/2;
    }

  }

  .item-title {
    grid-area: title;
  }

  .item-description {
    grid-area: description;
  }

  &:has(.item-image:hover) {
    .item-title * {
      color: ${getColor('textAccentPrimary')};
    }
  }

  &:has(.item-title:hover) {
    img {
      filter: brightness(80%);
    }
  }
`;
